module.exports = "pegasus_template/assets/website-announcement-background.png";